import React from "react";
import { Provider } from "react-redux";
import store from "./store/store";
import ReactDOM from "react-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import "semantic-ui-css/semantic.min.css";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "./index.css";
import "./utils/helpers/i18n";
import "react-toastify/dist/ReactToastify.css";
import { init } from "./utils/helpers/axios";
init();
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js